import dragon from './dragon_invite/pt.json';
import exchangeShop from './exchange_shop/pt.json';

export default {
    ...dragon,
    ...exchangeShop
};
